import React from 'react'
import withIcon from '@/components/withIcon'

const IconInsurance = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3903_170936)">
        <path
          d="M23.2495 3.96537L23.25 3.9655V3.9657C23.25 11.5641 20.4286 16.3692 17.6297 19.2819C14.8453 22.1793 12.0549 23.2307 12.0022 23.2505C12.0016 23.2507 12.0014 23.2508 12.0014 23.2508L12 23.2513L11.748 23.9577L12 23.2513L11.9985 23.2508C11.9987 23.2508 11.9984 23.2507 11.9978 23.2505C11.9451 23.2307 9.15466 22.1793 6.37034 19.2819C3.57136 16.3692 0.75 11.5641 0.75 3.9657L0.75 3.9655L0.750465 3.96537L12 0.752501L23.2495 3.96537Z"
          stroke="#162941"
          strokeWidth="1.5"
        />
        <path
          d="M7.875 12L10.875 15L16.875 7.5"
          stroke="#162941"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3903_170936">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default withIcon(IconInsurance)
